/* eslint-disable jsx-a11y/label-has-for */
import PropTypes from 'prop-types';

import CustomIcon from '../CustomIcons';

const CheckedBox = () => <CustomIcon type="checkbox" className="checked" />;
const UncheckedBox = () => <CustomIcon type="checkboxBlank" className="unchecked" />;

const Checkbox = ({ onClick, checked, disabled, label }) => (
  <div
    className="checkbox"
    disabled={disabled}
    onKeyUp={!disabled ? onClick : null}
    onClick={!disabled ? onClick : null}
  >
    <div className="checkbox-state">{checked ? <CheckedBox /> : <UncheckedBox />}</div>
    <label htmlFor={label} className="eta">
      {label}
    </label>
  </div>
);

Checkbox.propTypes = {
  checked: PropTypes.bool,
  disabled: PropTypes.bool,
  onClick: PropTypes.func,
  label: PropTypes.string
};

Checkbox.defaultProps = {
  checked: false,
  disabled: false,
  onClick: () => {},
  label: ''
};

export default Checkbox;
